import React from 'react';

import css from './BooksLabel.module.scss';

interface Props {
  label: string;
}

const BooksLabel = ({ label }: Props) => {
  return <span className={css.BooksLabel}>{label}</span>;
};

export default BooksLabel;
